import React from 'react'

import PropTypes from 'prop-types'

import { Input, Label, ErrorContainer, Container, InputWrapper, Suffix } from './styled'

const TextInputSuffix = ({
  placeholder,
  placeholderColor,
  topIcon,
  rightIcon,
  value,
  onChange,
  Icon,
  width,
  respWidth,
  height,
  refProp,
  borderRadius,
  border,
  onKeyDown,
  margin,
  onFocus,
  onBlur,
  padding,
  background,
  name,
  error,
  position,
  bottom,
  left,
  borderTop,
  shadow,
  type,
  disabled,
  maxLength,
  color,
  suffix,
}) => (
  <Container margin={margin} width={width} respWidth={respWidth} position={position} bottom={bottom} left={left}>
    <Label
      background={background}
      borderRadius={borderRadius}
      topIcon={topIcon}
      rightIcon={rightIcon}
      paddingLeft='1rem'
    >
      <InputWrapper>
        <Input
          onKeyDown={onKeyDown}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          placeholderColor={placeholderColor}
          ref={refProp}
          borderRadius={borderRadius}
          border={border}
          borderTop={borderTop}
          onFocus={onFocus}
          onBlur={onBlur}
          padding={padding}
          height={height}
          name={name}
          error={error}
          shadow={shadow}
          type={type}
          disabled={disabled}
          maxLength={maxLength}
          color={color}
          suffix={suffix}
        />
        {suffix && <Suffix value={value}>{value && value !== '' ? suffix : ''}</Suffix>}
      </InputWrapper>
      <Icon className='icon-input' />
    </Label>
    {error && <ErrorContainer>{error}</ErrorContainer>}
  </Container>
)

TextInputSuffix.propTypes = {
  placeholder: PropTypes.string,
  placeholderColor: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  width: PropTypes.string,
  respWidth: PropTypes.string,
  refProp: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  borderRadius: PropTypes.string,
  border: PropTypes.string,
  borderTop: PropTypes.string,
  onKeyDown: PropTypes.func,
  topIcon: PropTypes.string,
  rightIcon: PropTypes.string,
  margin: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  padding: PropTypes.string,
  background: PropTypes.string,
  height: PropTypes.string,
  name: PropTypes.string,
  error: PropTypes.string,
  position: PropTypes.string,
  bottom: PropTypes.string,
  left: PropTypes.string,
  shadow: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  maxLength: PropTypes.number,
  color: PropTypes.string,
  suffix: PropTypes.string,
}

TextInputSuffix.defaultProps = {
  placeholder: '',
  placeholderColor: '',
  value: '',
  onChange: () => {},
  Icon: () => <></>,
  width: '100%',
  respWidth: '',
  refProp: () => {},
  borderRadius: '8px',
  border: '',
  borderTop: '',
  onKeyDown: () => {},
  rightIcon: '1rem',
  topIcon: '1.5rem',
  margin: '',
  onFocus: () => {},
  onBlur: () => {},
  padding: '1rem',
  background: '',
  height: '40px',
  name: '',
  error: '',
  position: '',
  bottom: '',
  left: '',
  shadow: '',
  type: '',
  disabled: false,
  maxLength: null,
  color: '',
  suffix: null,
}

export default TextInputSuffix
